'use client';

import React from 'react';
import { useMediaQuery as q } from 'react-responsive';

export default function useMediaQuery() {
  const isMobile = q({ query: '(max-width: 600px)' });
  const isTablet = q({ query: '(min-width: 601px) and (max-width: 1023px)' });
  const isDesktop = q({ query: '(min-width: 901px)' });
  const isLandscape = q({ query: '(max-height: 600px)' });

  return {
    isMobile,
    isTablet,
    isDesktop,
    isLandscape,
  };
}
